import PropTypes from 'prop-types';
import React from 'react';

const CustomLink = ({ node, href, children, ...props }) => {
  const linkEl = (() => {
    try {
      const url = new URL(href, window.location.origin);
      if (!['http:', 'https:', 'mailto:'].includes(url.protocol)) {
        return null;
      }
    } catch {
      return null;
    }

    return (
      <a
        {...props}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary underline cursor-pointer font-medium"
      >
        [Visit Link]
      </a>
    );
  })();

  return (
    <div className="flex gap-x-2">
      {children}
      {linkEl}
    </div>
  );
};

CustomLink.propTypes = {
  node: PropTypes.object,
  href: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default CustomLink;
